<template>
  <v-btn class="next btn-label" :disabled="isDisabled"  color="primary" block @click="$emit('click', arguments)">
    <v-icon>$sl-arrow-right</v-icon>
    <!-- Default slot -->
    <slot></slot>
    
  </v-btn>
</template>

<script>
// @group Common
// Styled NextButton component

export default {
props: {
  //is disabled
    isDisabled: {
      type: Boolean,
       // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    }
  },
}
</script>

<style>
/* .theme--light.v-btn.btn-label .v-icon {
  opacity: 0.65 !important;
  filter: alpha(opacity=65) !important; /* For IE8 and earlier 
} */
</style>